"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionFooter = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
var _useQuestionnaireNavigation = require("../../hooks/questionnaire/useQuestionnaireNavigation");
var _services = require("../../services");
var _QuestionHeader = require("./QuestionHeader");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _QuestionFooterNextButton = _interopRequireDefault(require("./QuestionFooterNextButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
  width: ${props => props.width};
  & #questionnaire-button-next {
    font-size: ${prop => prop.actionButtonFontSize}px;
  }
  & #questionnaire-button-back {
    font-size: ${prop => prop.actionButtonFontSize}px;
  }
  ${props => props.adjustSmallFooterButtonStyle && `
     @media(max-width: 360px){
  & .buttonsContainer{
    max-width: 100%;
    margin: 0;

    & .buttonWrapper{
      max-width: 47%;
      padding: 0px;
      & button{
        min-width: 140px;
        font-size:18px;
      }
    }
  }
  & .singleButtonContainer{
    padding: 0;
  }  
}

 @media(max-width: 325px){
  & .buttonsContainer .buttonWrapper{
   max-width: 48%;
  }
 
} 
}
  @media(min-width: 768px){
    padding: 0 5px;
  }
    `}
`;
const ButtonRight = _styledComponents.default.div(props => (0, _styledComponents.css)`
      display: flex;
      justify-content: ${props.buttonStyle};
      width: 100%;
    `);
const QuestionFooter = () => {
  var _buttonTheme$appearan, _buttonTheme$appearan2, _buttonTheme$appearan3, _buttonTheme$appearan4;
  const {
    onNext,
    onBack,
    isBackVisible,
    isNextEnabled,
    isRestartVisible,
    onRestart
  } = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)();
  const nextButtonAppearance = isNextEnabled ? 'primary' : 'secondary';
  const nextButtonState = isNextEnabled ? '' : 'disabled';
  const buttonTheme = (0, _useLocalTheme.default)('button');
  const adjustButtons = (0, _useLocalTheme.default)('adjustButtons', false);
  const keepBackNextButtonsStylesInSmall = (0, _useLocalTheme.default)('keepBackNextButtonsStylesInSmall', false);
  const nextButtonColumns = (0, _useLocalTheme.default)('nextButton.columns', 8);
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const showStickyFooter = (0, _useConfig.default)('uiSettings.showStickyFooter', false);
  const showBroadbandModal = (0, _useConfig.default)('uiSettings.showBroadbandModal', false);
  const broadbandMargins = {
    bottom: 0,
    top: 0
  };
  const margins = (0, _react.useMemo)(() => showStickyFooter ? {
    bottom: 6,
    top: 4
  } : {
    bottom: 0,
    top: 0
  }, [showStickyFooter]);
  const footerMargins = (0, _react.useMemo)(() => showBroadbandModal ? broadbandMargins : margins, [showBroadbandModal]);
  const buttonStyle = (0, _react.useMemo)(() => showBroadbandModal ? 'flex-end' : 'center', [showBroadbandModal]);
  const smallFooterWidth = (0, _useLocalTheme.default)('modalBody.smallFooterWidth', '100%');
  const largeFooterWidth = (0, _useLocalTheme.default)('modalBody.footerWidth', '100%');
  const adjustSmallFooterButtonStyle = (0, _useLocalTheme.default)('adjustSmallFooterButtonStyle', false);
  const footerWidth = breakpoints.sm ? smallFooterWidth : largeFooterWidth;
  const actionButtonFontSize = (0, _useLocalTheme.default)('actionButtonFontSize');
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    id: "question-footer",
    width: footerWidth,
    adjustSmallFooterButtonStyle: adjustSmallFooterButtonStyle,
    actionButtonFontSize: actionButtonFontSize
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: footerMargins.bottom,
      top: footerMargins.top
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center',
    className: "buttonsContainer"
  }, isBackVisible ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'between',
    direction: keepBackNextButtonsStylesInSmall && breakpoints.sm ? 'row-reverse' : ''
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: adjustButtons ? 4 : 6
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.Services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: adjustButtons ? 4 : 6
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan2 = buttonTheme.appearance) === null || _buttonTheme$appearan2 === void 0 ? void 0 : _buttonTheme$appearan2[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.Services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: keepBackNextButtonsStylesInSmall ? 6 : 12,
    className: "buttonWrapper"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan3 = buttonTheme.appearance) === null || _buttonTheme$appearan3 === void 0 ? void 0 : _buttonTheme$appearan3[nextButtonAppearance],
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-next",
    width: 'full',
    text: _services.Services.locale.localeString('Questionnaire.ButtonNext'),
    appearance: nextButtonAppearance,
    state: nextButtonState,
    onClick: onNext
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: keepBackNextButtonsStylesInSmall ? 6 : 12,
    className: "buttonWrapper"
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan4 = buttonTheme.appearance) === null || _buttonTheme$appearan4 === void 0 ? void 0 : _buttonTheme$appearan4.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    id: "questionnaire-button-back",
    text: _services.Services.locale.localeString('Questionnaire.ButtonBack'),
    width: 'full',
    appearance: "alt1",
    onClick: onBack
  })))))) : /*#__PURE__*/_react.default.createElement(_QuestionFooterNextButton.default, {
    buttonTheme: buttonTheme,
    buttonStyle: buttonStyle,
    nextButtonAppearance: nextButtonAppearance,
    nextButtonState: nextButtonState,
    onNext: onNext,
    nextButtonColumns: nextButtonColumns
  })), isRestartVisible && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "restart-button"
  }, /*#__PURE__*/_react.default.createElement(_QuestionHeader.RestartBtnComponent, {
    isRestartVisible: isRestartVisible,
    onRestart: onRestart,
    placement: "footer"
  })))));
};
exports.QuestionFooter = QuestionFooter;